import React, { useEffect, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import Alert from "../../Common/Alert";
import DatatableFunc from "../../Common/DatatableFunc";
import Http from "../../Common/Http";
import IsLogin from "../../Common/IsLogin";
import { LoaderComponent } from "../../Common/LoaderComponent";
import ReactDataTable from "../../Common/ReactDataTable";

const List = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [error, setError] = useState({});
  const [receiveData, setReceiveData] = useState([]);
  const [alert, setAlert] = useState(null);
  const [loading, setLoading] = useState(false);

  const fetchData = () => {
    Http.get("/code").then((res) => {
      setReceiveData(res.data);
      document.getElementById("app-title").innerText = `(0) Artisan ERP`;
    });
  };

  useEffect(() => {
    DatatableFunc();
    fetchData();
  }, []);

  const markAsRead = (id) => {
    Http.get("/notifications/" + id + "/mark-as-read")
      .then((res) => {
        Swal.fire("Mark As Read!", "Mark As Read", "success");
        Http.get("/notifications").then((res) => {
          setReceiveData(res.data);
        });
      })
      .catch(function (e) {
        setError(e.response.data.errors);
      });
  };

  const deleteImage = (id) => {
    Swal.fire({
      title: "Are you sure?",
      text: "You won't be able to revert this!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, delete it!",
    }).then((result) => {
      if (result.isConfirmed) {
        Http.delete("/code/" + id)
          .then((res) => {
            Swal.fire("Deleted!", "Code has been deleted.", "success");
            fetchData();
            navigate("/code");
          })
          .catch((error) => {
            Swal.fire(
              "Error!",
              "An error occurred while deleting the image.",
              "error"
            );
          });
      }
    });
  };

  const cols = [
    { field: "code", header: "Code" },
    {
      field: (item) => (
        <div>
          {/* <Link
            to={`/edit-code/${item.id}`}
            className="btn btn-primary btn-sm me-2"
            title="Edit code"
          >
            <i className="fa fa-edit"></i>
          </Link> */}
          <Link
            onClick={() => deleteImage(item.id)}
            className="btn btn-danger btn-sm"
            title="Trash gless colour"
          >
            <i className="fa fa-trash"></i>
          </Link>
        </div>
      ),
      header: "Action",
    },
  ];

  return (
    <>
      <IsLogin />
      <div>
        <div className="am-mainpanel">
          <div className="am-pagetitle">
            <h5 className="am-title">Code</h5>
            <Link to="/create-code" className="btn btn-primary" title="Create code">
              <i className="fa fa-plus-square mg-r-6"></i>
              Create
            </Link>
          </div>

          <div className="am-pagebody">
            <Alert alert={alert} />

            <div className="card pd-20 pd-sm-40">
              <ReactDataTable
                cols={cols}
                receiveData={receiveData}
                isLoading={loading}
              />
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default List;
